import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Header from 'components/header';
import Footer from 'components/footer';

import './style.css';

const Page = ({ header, footer, className, children, theme }) => {
  const customClassName = classNames('page', className, `-${theme}`);
  return (
    <>
      <div className={customClassName}>
        {header ? <Header /> : null}
        <main>{children}</main>
        {footer ? <Footer /> : null}
      </div>
    </>
  );
};

Page.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.bool,
  footer: PropTypes.bool,
  theme: PropTypes.oneOf(['blue', 'white']),
};

Page.defaultProps = {
  className: null,
  header: true,
  footer: true,
  children: null,
  theme: 'blue',
};

export default Page;
